import { SVGProps } from "react";

export function NoteWithBG(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      {...props}
    >
      <circle cx="60" cy="60" r="60" fill="#FEF6E6" />
      <path
        d="M71.9953 40.8H47.9953C45.3443 40.8 43.1953 42.9491 43.1953 45.6V76.8C43.1953 79.451 45.3443 81.6001 47.9953 81.6001H71.9953C74.6463 81.6001 76.7953 79.451 76.7953 76.8V45.6C76.7953 42.9491 74.6463 40.8 71.9953 40.8Z"
        stroke="#F4A100"
        stroke-width="2.4"
      />
      <path
        d="M52.7969 52.8H67.1969M52.7969 62.4H67.1969M52.7969 72H62.3969"
        stroke="#F4A100"
        stroke-width="2.4"
        stroke-linecap="round"
      />
    </svg>
  );
}

